import { HydraboostProductSummaryMoleculeProps } from '.';
import { formatCurrency } from '../../../utils';

export const HydraboostProductSummaryMolecule = (
  props: HydraboostProductSummaryMoleculeProps
) => {
  return (
    <div data-cy="hydraboost-product-summary" className="w-full mt-5 h-18">
      <div className="flex justify-between">
        <div className="h-20 ">
          <img src="/images/products/daily_contact_lens.png" className="h-20" />
        </div>
        <div className="flex flex-col justify-end flex-1 md:flex-2">
          <h3 className="text-base font-waldo-sans pl-4 mb-2 font-semibold md:text-lg">
            Hydra Boost Daily Lenses
          </h3>
          <p className="text-base font-waldo-sans pl-4 mb-0.5 md:text-lg">
            180 contacts
          </p>
        </div>
        <p className="self-end text-base font-waldo-sans mb-0.5 text-right md:text-lg">
          {formatCurrency((props.price as number) || 0 / 180, 2, 2)} per lens
        </p>
      </div>
    </div>
  );
};
